/**
 * Construit le message à afficher quand POST /extranet/connexion/{google,microsoft} échoue.
 *
 * - 429 (limitation de débit) : « Réessayez dans N secondes » d'après l'en-tête Retry-After.
 * - Autres statuts : le `message` renvoyé par l'API (ex. abonnement sans accès extranet),
 *   sinon `fallback`.
 *
 * @param {Response} response - Réponse fetch non-ok
 * @param {string} fallback - Message par défaut
 * @returns {Promise<string>}
 */
export async function getLoginErrorMessage(response, fallback) {
  if (response.status === 429) {
    const seconds = parseInt(response.headers?.get('Retry-After'), 10);
    if (Number.isNaN(seconds)) {
      return 'Trop de tentatives de connexion. Réessayez dans quelques instants.';
    }
    return `Trop de tentatives de connexion. Réessayez dans ${seconds} seconde${seconds > 1 ? 's' : ''}.`;
  }

  try {
    const body = await response.json();
    if (body?.message) return body.message;
  } catch (e) {
    // Corps absent ou non JSON : message par défaut
  }
  return fallback;
}
